export const societeConcerne: { [key: string]: { "societe": string | string[] } } = {
    "Création EURL": {
        "societe": [
            "Entreprise unipersonnelle à responsabilité limitée",
            // "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            // "Exploitation agricole à responsabilité limitée",
            // "Groupement agricole d'exploitation en commun",
            // "Groupement foncier agricole",
            // "Société à responsabilité limitée",
            // "Société à responsabilité limitée à capital variable",
            // "Société anonyme",
            // "Société Civile",
            // "Société Civile de moyens",
            // "Société civile d'exploitation agricole",
            // "Société civile immobilière",
            // "Société civile immobilière à capital variable",
            // "Société civile immobilière de construction vente",
            // "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            // "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            // "Société d'exercice libéral à responsabilité limitée",
            // "Société d'exercice libéral par action simplifiée",
            // "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            // "Société en nom collectif",
            // "Société Interprofessionnelle de Soins Ambulatoires",
            // "Société par actions simplifiée",
            // "Société par actions simplifiée à capital variable",
            // "Société par actions simplifiée unipersonnelle",
            // "Société par actions simplifiée unipersonnelle à capital variable"
        ]
    },
    "Création GAEC": {
        "societe": [
            "Groupement agricole d'exploitation en commun",
            // "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            // "Entreprise unipersonnelle à responsabilité limitée",
            // "Exploitation agricole à responsabilité limitée",
            // "Groupement foncier agricole",
            // "Société à responsabilité limitée",
            // "Société à responsabilité limitée à capital variable",
            // "Société anonyme",
            // "Société Civile",
            // "Société Civile de moyens",
            // "Société civile d'exploitation agricole",
            // "Société civile immobilière",
            // "Société civile immobilière à capital variable",
            // "Société civile immobilière de construction vente",
            // "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            // "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            // "Société d'exercice libéral à responsabilité limitée",
            // "Société d'exercice libéral par action simplifiée",
            // "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            // "Société en nom collectif",
            // "Société Interprofessionnelle de Soins Ambulatoires",
            // "Société par actions simplifiée",
            // "Société par actions simplifiée à capital variable",
            // "Société par actions simplifiée unipersonnelle",
            // "Société par actions simplifiée unipersonnelle à capital variable"
        ]
    },
    "Création SA": {
        "societe": [
            "Société anonyme",
            // "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            // "Entreprise unipersonnelle à responsabilité limitée",
            // "Exploitation agricole à responsabilité limitée",
            // "Groupement agricole d'exploitation en commun",
            // "Groupement foncier agricole",
            // "Société à responsabilité limitée",
            // "Société à responsabilité limitée à capital variable",
            // "Société Civile",
            // "Société Civile de moyens",
            // "Société civile d'exploitation agricole",
            // "Société civile immobilière",
            // "Société civile immobilière à capital variable",
            // "Société civile immobilière de construction vente",
            // "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            // "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            // "Société d'exercice libéral à responsabilité limitée",
            // "Société d'exercice libéral par action simplifiée",
            // "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            // "Société en nom collectif",
            // "Société Interprofessionnelle de Soins Ambulatoires",
            // "Société par actions simplifiée",
            // "Société par actions simplifiée à capital variable",
            // "Société par actions simplifiée unipersonnelle",
            // "Société par actions simplifiée unipersonnelle à capital variable"
        ]
    },
    "Création SARL - SELARL": {
        "societe": [
            "Société à responsabilité limitée",
            "Société à responsabilité limitée à capital variable",
            "Société d'exercice libéral à responsabilité limitée",
            // "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            // "Entreprise unipersonnelle à responsabilité limitée",
            // "Exploitation agricole à responsabilité limitée",
            // "Groupement agricole d'exploitation en commun",
            // "Groupement foncier agricole",
            // "Société anonyme",
            // "Société Civile",
            // "Société Civile de moyens",
            // "Société civile d'exploitation agricole",
            // "Société civile immobilière",
            // "Société civile immobilière à capital variable",
            // "Société civile immobilière de construction vente",
            // "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            // "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            // "Société d'exercice libéral par action simplifiée",
            // "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            // "Société en nom collectif",
            // "Société Interprofessionnelle de Soins Ambulatoires",
            // "Société par actions simplifiée",
            // "Société par actions simplifiée à capital variable",
            // "Société par actions simplifiée unipersonnelle",
            // "Société par actions simplifiée unipersonnelle à capital variable"
        ]
    },
    "Création SAS": {
        "societe": [
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            "Société d'exercice libéral par action simplifiée",
            "Société par actions simplifiée",
            "Société par actions simplifiée à capital variable",
            // "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            // "Entreprise unipersonnelle à responsabilité limitée",
            // "Exploitation agricole à responsabilité limitée",
            // "Groupement agricole d'exploitation en commun",
            // "Groupement foncier agricole",
            // "Société à responsabilité limitée",
            // "Société à responsabilité limitée à capital variable",
            // "Société anonyme",
            // "Société Civile",
            // "Société Civile de moyens",
            // "Société civile d'exploitation agricole",
            // "Société civile immobilière",
            // "Société civile immobilière à capital variable",
            // "Société civile immobilière de construction vente",
            // "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            // "Société d'exercice libéral à responsabilité limitée",
            // "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            // "Société en nom collectif",
            // "Société Interprofessionnelle de Soins Ambulatoires",
            // "Société par actions simplifiée unipersonnelle",
            // "Société par actions simplifiée unipersonnelle à capital variable"
        ]
    },
    "Création SASU": {
        "societe": [
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            "Société par actions simplifiée unipersonnelle",
            "Société par actions simplifiée unipersonnelle à capital variable"
            // "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            // "Entreprise unipersonnelle à responsabilité limitée",
            // "Exploitation agricole à responsabilité limitée",
            // "Groupement agricole d'exploitation en commun",
            // "Groupement foncier agricole",
            // "Société à responsabilité limitée",
            // "Société à responsabilité limitée à capital variable",
            // "Société anonyme",
            // "Société Civile",
            // "Société Civile de moyens",
            // "Société civile d'exploitation agricole",
            // "Société civile immobilière",
            // "Société civile immobilière à capital variable",
            // "Société civile immobilière de construction vente",
            // "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            // "Société d'exercice libéral à responsabilité limitée",
            // "Société d'exercice libéral par action simplifiée",
            // "Société en nom collectif",
            // "Société Interprofessionnelle de Soins Ambulatoires",
            // "Société par actions simplifiée",
            // "Société par actions simplifiée à capital variable",
        ]
    },
    "Création SCI - SCCV": {
        "societe": [
            "Société civile immobilière",
            "Société civile immobilière à capital variable",
            "Société civile immobilière de construction vente",
        ],
    },
    "Création SNC": {
        "societe": [
            "Société en nom collectif",
            // "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            // "Exploitation agricole à responsabilité limitée",
            // "Groupement foncier agricole",
            // "Société Civile",
            // "Société Civile de moyens",
            // "Société civile d'exploitation agricole",
            // "Société Interprofessionnelle de Soins Ambulatoires",
            // "Entreprise unipersonnelle à responsabilité limitée",
            // "Groupement agricole d'exploitation en commun",
            // "Société à responsabilité limitée",
            // "Société à responsabilité limitée à capital variable",
            // "Société anonyme",
            // "Société civile immobilière",
            // "Société civile immobilière à capital variable",
            // "Société civile immobilière de construction vente",
            // "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            // "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            // "Société d'exercice libéral à responsabilité limitée",
            // "Société d'exercice libéral par action simplifiée",
            // "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            // "Société par actions simplifiée",
            // "Société par actions simplifiée à capital variable",
            // "Société par actions simplifiée unipersonnelle",
            // "Société par actions simplifiée unipersonnelle à capital variable"
        ],
    },
    "Création Société Civile": {
        "societe": [
            "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            "Exploitation agricole à responsabilité limitée",
            "Groupement foncier agricole",
            "Société Civile",
            "Société Civile de moyens",
            "Société Civile d'exploitation agricole",
            "Société Interprofessionnelle de Soins Ambulatoires",
        ],
    },
    "Nomination / Départ / Remplacement d'administrateur": {
        "societe": [
            "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            "Entreprise unipersonnelle à responsabilité limitée",
            "Exploitation agricole à responsabilité limitée",
            "Groupement agricole d'exploitation en commun",
            "Groupement foncier agricole",
            "Société à responsabilité limitée",
            "Société à responsabilité limitée à capital variable",
            "Société anonyme",
            "Société Civile",
            "Société Civile de moyens",
            "Société civile d'exploitation agricole",
            "Société civile immobilière",
            "Société civile immobilière à capital variable",
            "Société civile immobilière de construction vente",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            "Société d'exercice libéral à responsabilité limitée",
            "Société d'exercice libéral par action simplifiée",
            "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            "Société en nom collectif",
            "Société Interprofessionnelle de Soins Ambulatoires",
            "Société par actions simplifiée",
            "Société par actions simplifiée à capital variable",
            "Société par actions simplifiée unipersonnelle",
            "Société par actions simplifiée unipersonnelle à capital variable"
        ]
    },
    "Changement de dénomination": {
        "societe": [
            "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            "Entreprise unipersonnelle à responsabilité limitée",
            "Exploitation agricole à responsabilité limitée",
            "Groupement agricole d'exploitation en commun",
            "Groupement foncier agricole",
            "Société à responsabilité limitée",
            "Société à responsabilité limitée à capital variable",
            "Société anonyme",
            "Société Civile",
            "Société Civile de moyens",
            "Société civile d'exploitation agricole",
            "Société civile immobilière",
            "Société civile immobilière à capital variable",
            "Société civile immobilière de construction vente",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            "Société d'exercice libéral à responsabilité limitée",
            "Société d'exercice libéral par action simplifiée",
            "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            "Société en nom collectif",
            "Société Interprofessionnelle de Soins Ambulatoires",
            "Société par actions simplifiée",
            "Société par actions simplifiée à capital variable",
            "Société par actions simplifiée unipersonnelle",
            "Société par actions simplifiée unipersonnelle à capital variable"
        ]
    },
    "Changement de durée": {
        "societe": [
            "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            "Entreprise unipersonnelle à responsabilité limitée",
            "Exploitation agricole à responsabilité limitée",
            "Groupement agricole d'exploitation en commun",
            "Groupement foncier agricole",
            "Société à responsabilité limitée",
            "Société à responsabilité limitée à capital variable",
            "Société anonyme",
            "Société Civile",
            "Société Civile de moyens",
            "Société civile d'exploitation agricole",
            "Société civile immobilière",
            "Société civile immobilière à capital variable",
            "Société civile immobilière de construction vente",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            "Société d'exercice libéral à responsabilité limitée",
            "Société d'exercice libéral par action simplifiée",
            "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            "Société en nom collectif",
            "Société Interprofessionnelle de Soins Ambulatoires",
            "Société par actions simplifiée",
            "Société par actions simplifiée à capital variable",
            "Société par actions simplifiée unipersonnelle",
            "Société par actions simplifiée unipersonnelle à capital variable"
        ]
    },
    "Changement de dirigeant": {
        "societe": [
            "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            "Entreprise unipersonnelle à responsabilité limitée",
            "Exploitation agricole à responsabilité limitée",
            "Groupement agricole d'exploitation en commun",
            "Groupement foncier agricole",
            "Société à responsabilité limitée",
            "Société à responsabilité limitée à capital variable",
            "Société anonyme",
            "Société Civile",
            "Société Civile de moyens",
            "Société civile d'exploitation agricole",
            "Société civile immobilière",
            "Société civile immobilière à capital variable",
            "Société civile immobilière de construction vente",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            "Société d'exercice libéral à responsabilité limitée",
            "Société d'exercice libéral par action simplifiée",
            "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            "Société en nom collectif",
            "Société Interprofessionnelle de Soins Ambulatoires",
            "Société par actions simplifiée",
            "Société par actions simplifiée à capital variable",
            "Société par actions simplifiée unipersonnelle",
            "Société par actions simplifiée unipersonnelle à capital variable"
        ]
    },
    "Modification d'objet social": {
        "societe": [
            "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            "Entreprise unipersonnelle à responsabilité limitée",
            "Exploitation agricole à responsabilité limitée",
            "Groupement agricole d'exploitation en commun",
            "Groupement foncier agricole",
            "Société à responsabilité limitée",
            "Société à responsabilité limitée à capital variable",
            "Société anonyme",
            "Société Civile",
            "Société Civile de moyens",
            "Société civile d'exploitation agricole",
            "Société civile immobilière",
            "Société civile immobilière à capital variable",
            "Société civile immobilière de construction vente",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            "Société d'exercice libéral à responsabilité limitée",
            "Société d'exercice libéral par action simplifiée",
            "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            "Société en nom collectif",
            "Société Interprofessionnelle de Soins Ambulatoires",
            "Société par actions simplifiée",
            "Société par actions simplifiée à capital variable",
            "Société par actions simplifiée unipersonnelle",
            "Société par actions simplifiée unipersonnelle à capital variable",
        ],
    },
    "Modification du capital": {
        "societe": [
            "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            "Entreprise unipersonnelle à responsabilité limitée",
            "Exploitation agricole à responsabilité limitée",
            "Groupement agricole d'exploitation en commun",
            "Groupement foncier agricole",
            "Société à responsabilité limitée",
            "Société à responsabilité limitée à capital variable",
            "Société anonyme",
            "Société Civile",
            "Société Civile de moyens",
            "Société civile d'exploitation agricole",
            "Société civile immobilière",
            "Société civile immobilière à capital variable",
            "Société civile immobilière de construction vente",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            "Société d'exercice libéral à responsabilité limitée",
            "Société d'exercice libéral par action simplifiée",
            "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            "Société en nom collectif",
            "Société Interprofessionnelle de Soins Ambulatoires",
            "Société par actions simplifiée",
            "Société par actions simplifiée à capital variable",
            "Société par actions simplifiée unipersonnelle",
            "Société par actions simplifiée unipersonnelle à capital variable",
        ],
    },
    "Nomination/ Départ/ Remplacement de CAC": {
        "societe": [
            "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            "Entreprise unipersonnelle à responsabilité limitée",
            "Exploitation agricole à responsabilité limitée",
            "Groupement agricole d'exploitation en commun",
            "Groupement foncier agricole",
            "Société à responsabilité limitée",
            "Société à responsabilité limitée à capital variable",
            "Société anonyme",
            "Société Civile",
            "Société Civile de moyens",
            "Société civile d'exploitation agricole",
            "Société civile immobilière",
            "Société civile immobilière à capital variable",
            "Société civile immobilière de construction vente",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            "Société d'exercice libéral à responsabilité limitée",
            "Société d'exercice libéral par action simplifiée",
            "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            "Société en nom collectif",
            "Société Interprofessionnelle de Soins Ambulatoires",
            "Société par actions simplifiée",
            "Société par actions simplifiée à capital variable",
            "Société par actions simplifiée unipersonnelle",
            "Société par actions simplifiée unipersonnelle à capital variable",
        ],
    },
    "Transfert de siège dans le département": {
        "societe": [
            "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            "Entreprise unipersonnelle à responsabilité limitée",
            "Exploitation agricole à responsabilité limitée",
            "Groupement agricole d'exploitation en commun",
            "Groupement foncier agricole",
            "Société à responsabilité limitée",
            "Société à responsabilité limitée à capital variable",
            "Société anonyme",
            "Société Civile",
            "Société Civile de moyens",
            "Société civile d'exploitation agricole",
            "Société civile immobilière",
            "Société civile immobilière à capital variable",
            "Société civile immobilière de construction vente",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            "Société d'exercice libéral à responsabilité limitée",
            "Société d'exercice libéral par action simplifiée",
            "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            "Société en nom collectif",
            "Société Interprofessionnelle de Soins Ambulatoires",
            "Société par actions simplifiée",
            "Société par actions simplifiée à capital variable",
            "Société par actions simplifiée unipersonnelle",
            "Société par actions simplifiée unipersonnelle à capital variable",
        ],
    },
    "Transfert de siège hors département": {
        "societe": [
            "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            "Entreprise unipersonnelle à responsabilité limitée",
            "Exploitation agricole à responsabilité limitée",
            "Groupement agricole d'exploitation en commun",
            "Groupement foncier agricole",
            "Société à responsabilité limitée",
            "Société à responsabilité limitée à capital variable",
            "Société anonyme",
            "Société Civile",
            "Société Civile de moyens",
            "Société civile d'exploitation agricole",
            "Société civile immobilière",
            "Société civile immobilière à capital variable",
            "Société civile immobilière de construction vente",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            "Société d'exercice libéral à responsabilité limitée",
            "Société d'exercice libéral par action simplifiée",
            "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            "Société en nom collectif",
            "Société Interprofessionnelle de Soins Ambulatoires",
            "Société par actions simplifiée",
            "Société par actions simplifiée à capital variable",
            "Société par actions simplifiée unipersonnelle",
            "Société par actions simplifiée unipersonnelle à capital variable",
        ],
    },
    "Transformation SARL en SAS": {
        "societe": [
            "Entreprise unipersonnelle à responsabilité limitée",
            "Société à responsabilité limitée",
            "Société à responsabilité limitée à capital variable",
            "Société d'exercice libéral à responsabilité limitée",
        ],
    },
    "Transformation SARL en SCI": {
        "societe": [
            "Entreprise unipersonnelle à responsabilité limitée",
            "Société à responsabilité limitée",
            "Société civile immobilière",
            "Société civile immobilière à capital variable",
        ],
    },
    "Transformation SAS en SARL": {
        "societe": [
            "Société par actions simplifiée",
            "Société par actions simplifiée à capital variable",
        ],
    },
    "Transformation Autre": {
        "societe": [
            "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            "Entreprise unipersonnelle à responsabilité limitée",
            "Exploitation agricole à responsabilité limitée",
            "Groupement agricole d'exploitation en commun",
            "Groupement foncier agricole",
            "Société à responsabilité limitée",
            "Société à responsabilité limitée à capital variable",
            "Société anonyme",
            "Société Civile",
            "Société Civile de moyens",
            "Société civile d'exploitation agricole",
            "Société civile immobilière",
            "Société civile immobilière à capital variable",
            "Société civile immobilière de construction vente",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            "Société d'exercice libéral à responsabilité limitée",
            "Société d'exercice libéral par action simplifiée",
            "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            "Société en nom collectif",
            "Société Interprofessionnelle de Soins Ambulatoires",
            "Société par actions simplifiée",
            "Société par actions simplifiée à capital variable",
            "Société par actions simplifiée unipersonnelle",
            "Société par actions simplifiée unipersonnelle à capital variable"
        ]
    },
    "Fusion": {
        "societe": [
            "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            "Entreprise unipersonnelle à responsabilité limitée",
            "Exploitation agricole à responsabilité limitée",
            "Groupement agricole d'exploitation en commun",
            "Groupement foncier agricole",
            "Société à responsabilité limitée",
            "Société à responsabilité limitée à capital variable",
            "Société anonyme",
            "Société Civile",
            "Société Civile de moyens",
            "Société civile d'exploitation agricole",
            "Société civile immobilière",
            "Société civile immobilière à capital variable",
            "Société civile immobilière de construction vente",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            "Société d'exercice libéral à responsabilité limitée",
            "Société d'exercice libéral par action simplifiée",
            "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            "Société en nom collectif",
            "Société Interprofessionnelle de Soins Ambulatoires",
            "Société par actions simplifiée",
            "Société par actions simplifiée à capital variable",
            "Société par actions simplifiée unipersonnelle",
            "Société par actions simplifiée unipersonnelle à capital variable"
        ]
    },
    "Modifications multiples": {
        "societe": [
            "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            "Entreprise unipersonnelle à responsabilité limitée",
            "Exploitation agricole à responsabilité limitée",
            "Groupement agricole d'exploitation en commun",
            "Groupement foncier agricole",
            "Société à responsabilité limitée",
            "Société à responsabilité limitée à capital variable",
            "Société anonyme",
            "Société Civile",
            "Société Civile de moyens",
            "Société civile d'exploitation agricole",
            "Société civile immobilière",
            "Société civile immobilière à capital variable",
            "Société civile immobilière de construction vente",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            "Société d'exercice libéral à responsabilité limitée",
            "Société d'exercice libéral par action simplifiée",
            "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            "Société en nom collectif",
            "Société Interprofessionnelle de Soins Ambulatoires",
            "Société par actions simplifiée",
            "Société par actions simplifiée à capital variable",
            "Société par actions simplifiée unipersonnelle",
            "Société par actions simplifiée unipersonnelle à capital variable"
        ]
    },
    "Modification Autre": {
        "societe": [
            "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            "Entreprise unipersonnelle à responsabilité limitée",
            "Exploitation agricole à responsabilité limitée",
            "Groupement agricole d'exploitation en commun",
            "Groupement foncier agricole",
            "Société à responsabilité limitée",
            "Société à responsabilité limitée à capital variable",
            "Société anonyme",
            "Société Civile",
            "Société Civile de moyens",
            "Société civile d'exploitation agricole",
            "Société civile immobilière",
            "Société civile immobilière à capital variable",
            "Société civile immobilière de construction vente",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            "Société d'exercice libéral à responsabilité limitée",
            "Société d'exercice libéral par action simplifiée",
            "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            "Société en nom collectif",
            "Société Interprofessionnelle de Soins Ambulatoires",
            "Société par actions simplifiée",
            "Société par actions simplifiée à capital variable",
            "Société par actions simplifiée unipersonnelle",
            "Société par actions simplifiée unipersonnelle à capital variable"
        ]
    },
    "Ouverture Dissolution Anticipée": {
        "societe": [
            "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            "Entreprise unipersonnelle à responsabilité limitée",
            "Exploitation agricole à responsabilité limitée",
            "Groupement agricole d'exploitation en commun",
            "Groupement foncier agricole",
            "Société à responsabilité limitée",
            "Société à responsabilité limitée à capital variable",
            "Société anonyme",
            "Société Civile",
            "Société Civile de moyens",
            "Société civile d'exploitation agricole",
            "Société civile immobilière",
            "Société civile immobilière à capital variable",
            "Société civile immobilière de construction vente",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            "Société d'exercice libéral à responsabilité limitée",
            "Société d'exercice libéral par action simplifiée",
            "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            "Société en nom collectif",
            "Société Interprofessionnelle de Soins Ambulatoires",
            "Société par actions simplifiée",
            "Société par actions simplifiée à capital variable",
            "Société par actions simplifiée unipersonnelle",
            "Société par actions simplifiée unipersonnelle à capital variable"
        ]
    },
    "Clôture de liquidation": {
        "societe": [
            "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            "Entreprise unipersonnelle à responsabilité limitée",
            "Exploitation agricole à responsabilité limitée",
            "Groupement agricole d'exploitation en commun",
            "Groupement foncier agricole",
            "Société à responsabilité limitée",
            "Société à responsabilité limitée à capital variable",
            "Société anonyme",
            "Société Civile",
            "Société Civile de moyens",
            "Société civile d'exploitation agricole",
            "Société civile immobilière",
            "Société civile immobilière à capital variable",
            "Société civile immobilière de construction vente",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            "Société d'exercice libéral à responsabilité limitée",
            "Société d'exercice libéral par action simplifiée",
            "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            "Société en nom collectif",
            "Société Interprofessionnelle de Soins Ambulatoires",
            "Société par actions simplifiée",
            "Société par actions simplifiée à capital variable",
            "Société par actions simplifiée unipersonnelle",
            "Société par actions simplifiée unipersonnelle à capital variable"
        ]
    },
    "TUP - Dissolution sans liquidation": {
        "societe": [
            "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            "Entreprise unipersonnelle à responsabilité limitée",
            "Exploitation agricole à responsabilité limitée",
            "Groupement agricole d'exploitation en commun",
            "Groupement foncier agricole",
            "Société à responsabilité limitée",
            "Société à responsabilité limitée à capital variable",
            "Société anonyme",
            "Société Civile",
            "Société Civile de moyens",
            "Société civile d'exploitation agricole",
            "Société civile immobilière",
            "Société civile immobilière à capital variable",
            "Société civile immobilière de construction vente",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            "Société d'exercice libéral à responsabilité limitée",
            "Société d'exercice libéral par action simplifiée",
            "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            "Société en nom collectif",
            "Société Interprofessionnelle de Soins Ambulatoires",
            "Société par actions simplifiée",
            "Société par actions simplifiée à capital variable",
            "Société par actions simplifiée unipersonnelle",
            "Société par actions simplifiée unipersonnelle à capital variable"
        ]
    },
    "Cession de droit au bail": {
        "societe": [
            "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            "Entreprise unipersonnelle à responsabilité limitée",
            "Exploitation agricole à responsabilité limitée",
            "Groupement agricole d'exploitation en commun",
            "Groupement foncier agricole",
            "Société à responsabilité limitée",
            "Société à responsabilité limitée à capital variable",
            "Société anonyme",
            "Société Civile",
            "Société Civile de moyens",
            "Société civile d'exploitation agricole",
            "Société civile immobilière",
            "Société civile immobilière à capital variable",
            "Société civile immobilière de construction vente",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            "Société d'exercice libéral à responsabilité limitée",
            "Société d'exercice libéral par action simplifiée",
            "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            "Société en nom collectif",
            "Société Interprofessionnelle de Soins Ambulatoires",
            "Société par actions simplifiée",
            "Société par actions simplifiée à capital variable",
            "Société par actions simplifiée unipersonnelle",
            "Société par actions simplifiée unipersonnelle à capital variable"
        ]
    },
    "Cession de fonds de commerce": {
        "societe": [
            "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            "Entreprise unipersonnelle à responsabilité limitée",
            "Exploitation agricole à responsabilité limitée",
            "Groupement agricole d'exploitation en commun",
            "Groupement foncier agricole",
            "Société à responsabilité limitée",
            "Société à responsabilité limitée à capital variable",
            "Société anonyme",
            "Société Civile",
            "Société Civile de moyens",
            "Société civile d'exploitation agricole",
            "Société civile immobilière",
            "Société civile immobilière à capital variable",
            "Société civile immobilière de construction vente",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            "Société d'exercice libéral à responsabilité limitée",
            "Société d'exercice libéral par action simplifiée",
            "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            "Société en nom collectif",
            "Société Interprofessionnelle de Soins Ambulatoires",
            "Société par actions simplifiée",
            "Société par actions simplifiée à capital variable",
            "Société par actions simplifiée unipersonnelle",
            "Société par actions simplifiée unipersonnelle à capital variable"
        ]
    },
    "Changement de nom patronymique": {
        "societe": [
            "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            "Entreprise unipersonnelle à responsabilité limitée",
            "Exploitation agricole à responsabilité limitée",
            "Groupement agricole d'exploitation en commun",
            "Groupement foncier agricole",
            "Société à responsabilité limitée",
            "Société à responsabilité limitée à capital variable",
            "Société anonyme",
            "Société Civile",
            "Société Civile de moyens",
            "Société civile d'exploitation agricole",
            "Société civile immobilière",
            "Société civile immobilière à capital variable",
            "Société civile immobilière de construction vente",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            "Société d'exercice libéral à responsabilité limitée",
            "Société d'exercice libéral par action simplifiée",
            "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            "Société en nom collectif",
            "Société Interprofessionnelle de Soins Ambulatoires",
            "Société par actions simplifiée",
            "Société par actions simplifiée à capital variable",
            "Société par actions simplifiée unipersonnelle",
            "Société par actions simplifiée unipersonnelle à capital variable"
        ]
    },
    "Changement de régime matrimonial": {
        "societe": [
            "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            "Entreprise unipersonnelle à responsabilité limitée",
            "Exploitation agricole à responsabilité limitée",
            "Groupement agricole d'exploitation en commun",
            "Groupement foncier agricole",
            "Société à responsabilité limitée",
            "Société à responsabilité limitée à capital variable",
            "Société anonyme",
            "Société Civile",
            "Société Civile de moyens",
            "Société civile d'exploitation agricole",
            "Société civile immobilière",
            "Société civile immobilière à capital variable",
            "Société civile immobilière de construction vente",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            "Société d'exercice libéral à responsabilité limitée",
            "Société d'exercice libéral par action simplifiée",
            "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            "Société en nom collectif",
            "Société Interprofessionnelle de Soins Ambulatoires",
            "Société par actions simplifiée",
            "Société par actions simplifiée à capital variable",
            "Société par actions simplifiée unipersonnelle",
            "Société par actions simplifiée unipersonnelle à capital variable"
        ]
    },
    "Changement d'associé": {
        "societe": [
            "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            "Entreprise unipersonnelle à responsabilité limitée",
            "Exploitation agricole à responsabilité limitée",
            "Groupement agricole d'exploitation en commun",
            "Groupement foncier agricole",
            "Société à responsabilité limitée",
            "Société à responsabilité limitée à capital variable",
            "Société anonyme",
            "Société Civile",
            "Société Civile de moyens",
            "Société civile d'exploitation agricole",
            "Société civile immobilière",
            "Société civile immobilière à capital variable",
            "Société civile immobilière de construction vente",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            "Société d'exercice libéral à responsabilité limitée",
            "Société d'exercice libéral par action simplifiée",
            "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            "Société en nom collectif",
            "Société Interprofessionnelle de Soins Ambulatoires",
            "Société par actions simplifiée",
            "Société par actions simplifiée à capital variable",
            "Société par actions simplifiée unipersonnelle",
            "Société par actions simplifiée unipersonnelle à capital variable"
        ]
    },
    "Continuation d'activité malgré pertes": {
        "societe": [
            "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            "Entreprise unipersonnelle à responsabilité limitée",
            "Exploitation agricole à responsabilité limitée",
            "Groupement agricole d'exploitation en commun",
            "Groupement foncier agricole",
            "Société à responsabilité limitée",
            "Société à responsabilité limitée à capital variable",
            "Société anonyme",
            "Société Civile",
            "Société Civile de moyens",
            "Société civile d'exploitation agricole",
            "Société civile immobilière",
            "Société civile immobilière à capital variable",
            "Société civile immobilière de construction vente",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            "Société d'exercice libéral à responsabilité limitée",
            "Société d'exercice libéral par action simplifiée",
            "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            "Société en nom collectif",
            "Société Interprofessionnelle de Soins Ambulatoires",
            "Société par actions simplifiée",
            "Société par actions simplifiée à capital variable",
            "Société par actions simplifiée unipersonnelle",
            "Société par actions simplifiée unipersonnelle à capital variable"
        ]
    },
    "Nomination / Départ / Remplacement de CAC": {
        "societe": [
            "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            "Entreprise unipersonnelle à responsabilité limitée",
            "Exploitation agricole à responsabilité limitée",
            "Groupement agricole d'exploitation en commun",
            "Groupement foncier agricole",
            "Société à responsabilité limitée",
            "Société à responsabilité limitée à capital variable",
            "Société anonyme",
            "Société Civile",
            "Société Civile de moyens",
            "Société civile d'exploitation agricole",
            "Société civile immobilière",
            "Société civile immobilière à capital variable",
            "Société civile immobilière de construction vente",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            "Société d'exercice libéral à responsabilité limitée",
            "Société d'exercice libéral par action simplifiée",
            "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            "Société en nom collectif",
            "Société Interprofessionnelle de Soins Ambulatoires",
            "Société par actions simplifiée",
            "Société par actions simplifiée à capital variable",
            "Société par actions simplifiée unipersonnelle",
            "Société par actions simplifiée unipersonnelle à capital variable"
        ]
    },
    "Déclaration d'insaisissabilité": {
        "societe": [
            "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            "Entreprise unipersonnelle à responsabilité limitée",
            "Exploitation agricole à responsabilité limitée",
            "Groupement agricole d'exploitation en commun",
            "Groupement foncier agricole",
            "Société à responsabilité limitée",
            "Société à responsabilité limitée à capital variable",
            "Société anonyme",
            "Société Civile",
            "Société Civile de moyens",
            "Société civile d'exploitation agricole",
            "Société civile immobilière",
            "Société civile immobilière à capital variable",
            "Société civile immobilière de construction vente",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            "Société d'exercice libéral à responsabilité limitée",
            "Société d'exercice libéral par action simplifiée",
            "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            "Société en nom collectif",
            "Société Interprofessionnelle de Soins Ambulatoires",
            "Société par actions simplifiée",
            "Société par actions simplifiée à capital variable",
            "Société par actions simplifiée unipersonnelle",
            "Société par actions simplifiée unipersonnelle à capital variable"
        ]
    },
    "Envoi en possession": {
        "societe": [
            "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            "Entreprise unipersonnelle à responsabilité limitée",
            "Exploitation agricole à responsabilité limitée",
            "Groupement agricole d'exploitation en commun",
            "Groupement foncier agricole",
            "Société à responsabilité limitée",
            "Société à responsabilité limitée à capital variable",
            "Société anonyme",
            "Société Civile",
            "Société Civile de moyens",
            "Société civile d'exploitation agricole",
            "Société civile immobilière",
            "Société civile immobilière à capital variable",
            "Société civile immobilière de construction vente",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            "Société d'exercice libéral à responsabilité limitée",
            "Société d'exercice libéral par action simplifiée",
            "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            "Société en nom collectif",
            "Société Interprofessionnelle de Soins Ambulatoires",
            "Société par actions simplifiée",
            "Société par actions simplifiée à capital variable",
            "Société par actions simplifiée unipersonnelle",
            "Société par actions simplifiée unipersonnelle à capital variable"
        ]
    },
    "Acceptation de la succession à concurrence de l'actif net": {
        "societe": [
            "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            "Entreprise unipersonnelle à responsabilité limitée",
            "Exploitation agricole à responsabilité limitée",
            "Groupement agricole d'exploitation en commun",
            "Groupement foncier agricole",
            "Société à responsabilité limitée",
            "Société à responsabilité limitée à capital variable",
            "Société anonyme",
            "Société Civile",
            "Société Civile de moyens",
            "Société civile d'exploitation agricole",
            "Société civile immobilière",
            "Société civile immobilière à capital variable",
            "Société civile immobilière de construction vente",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            "Société d'exercice libéral à responsabilité limitée",
            "Société d'exercice libéral par action simplifiée",
            "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            "Société en nom collectif",
            "Société Interprofessionnelle de Soins Ambulatoires",
            "Société par actions simplifiée",
            "Société par actions simplifiée à capital variable",
            "Société par actions simplifiée unipersonnelle",
            "Société par actions simplifiée unipersonnelle à capital variable"
        ]
    },
    "Fin de location gérance": {
        "societe": [
            "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            "Entreprise unipersonnelle à responsabilité limitée",
            "Exploitation agricole à responsabilité limitée",
            "Groupement agricole d'exploitation en commun",
            "Groupement foncier agricole",
            "Société à responsabilité limitée",
            "Société à responsabilité limitée à capital variable",
            "Société anonyme",
            "Société Civile",
            "Société Civile de moyens",
            "Société civile d'exploitation agricole",
            "Société civile immobilière",
            "Société civile immobilière à capital variable",
            "Société civile immobilière de construction vente",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            "Société d'exercice libéral à responsabilité limitée",
            "Société d'exercice libéral par action simplifiée",
            "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            "Société en nom collectif",
            "Société Interprofessionnelle de Soins Ambulatoires",
            "Société par actions simplifiée",
            "Société par actions simplifiée à capital variable",
            "Société par actions simplifiée unipersonnelle",
            "Société par actions simplifiée unipersonnelle à capital variable"
        ]
    },
    "Location gérance": {
        "societe": [
            "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            "Entreprise unipersonnelle à responsabilité limitée",
            "Exploitation agricole à responsabilité limitée",
            "Groupement agricole d'exploitation en commun",
            "Groupement foncier agricole",
            "Société à responsabilité limitée",
            "Société à responsabilité limitée à capital variable",
            "Société anonyme",
            "Société Civile",
            "Société Civile de moyens",
            "Société civile d'exploitation agricole",
            "Société civile immobilière",
            "Société civile immobilière à capital variable",
            "Société civile immobilière de construction vente",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            "Société d'exercice libéral à responsabilité limitée",
            "Société d'exercice libéral par action simplifiée",
            "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            "Société en nom collectif",
            "Société Interprofessionnelle de Soins Ambulatoires",
            "Société par actions simplifiée",
            "Société par actions simplifiée à capital variable",
            "Société par actions simplifiée unipersonnelle",
            "Société par actions simplifiée unipersonnelle à capital variable"
        ]
    },
    "Autre (rédaction libre)": {
        "societe": [
            "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            "Entreprise unipersonnelle à responsabilité limitée",
            "Exploitation agricole à responsabilité limitée",
            "Groupement agricole d'exploitation en commun",
            "Groupement foncier agricole",
            "Société à responsabilité limitée",
            "Société à responsabilité limitée à capital variable",
            "Société anonyme",
            "Société Civile",
            "Société Civile de moyens",
            "Société civile d'exploitation agricole",
            "Société civile immobilière",
            "Société civile immobilière à capital variable",
            "Société civile immobilière de construction vente",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            "Société d'exercice libéral à responsabilité limitée",
            "Société d'exercice libéral par action simplifiée",
            "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            "Société en nom collectif",
            "Société Interprofessionnelle de Soins Ambulatoires",
            "Société par actions simplifiée",
            "Société par actions simplifiée à capital variable",
            "Société par actions simplifiée unipersonnelle",
            "Société par actions simplifiée unipersonnelle à capital variable"
        ]
    },
    "Association d'Avocats": {
        "societe": "Association d'Avocats à Responsabilité Professionnelle Individuelle",
    },
    "Exploitation Agricole": {
        "societe": [
            "Exploitation agricole à responsabilité limitée",
            "Groupement agricole d'exploitation en commun",
            "Groupement foncier agricole",
        ],
    },
    "Société à Responsabilité Limitée": {
        "societe": [
            "Société à responsabilité limitée",
            "Société à responsabilité limitée à capital variable",
        ],
    },
    "Société Anonyme": {
        "societe": "Société anonyme",
    },
    "Société Civile": {
        "societe": [
            "Société Civile",
            "Société Civile de moyens",
            "Société civile d'exploitation agricole",
            "Société civile immobilière",
            "Société civile immobilière à capital variable",
            "Société civile immobilière de construction vente",
        ],
    },
    "Société de Participations Financières": {
        "societe": [
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
        ],
    },
    "Société d'Exercice Libéral": {
        "societe": [
            "Société d'exercice libéral à responsabilité limitée",
            "Société d'exercice libéral par action simplifiée",
            "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
        ],
    },
    "Société en Nom Collectif": {
        "societe": "Société en nom collectif",
    },
    "Société Interprofessionnelle de Soins Ambulatoires": {
        "societe": "Société Interprofessionnelle de Soins Ambulatoires",
    },
    "Société par Actions Simplifiée": {
        "societe": [
            "Société par actions simplifiée",
            "Société par actions simplifiée à capital variable",
            "Société par actions simplifiée unipersonnelle",
            "Société par actions simplifiée unipersonnelle à capital variable",
        ],
    },
    "Création SCIC - SCOP SA": {
        "societe": [
            "Société coopérative de production à forme anonyme à Conseil d'Administration",
            "Société coopérative de production à forme anonyme à Directoire",
            "Société coopérative d'intérêt collectif à forme anonyme à Conseil d'Administration",
            "Société coopérative d'intérêt collectif à forme anonyme à Directoire",
        ],
    },
    "Création SCIC - SCOP SARL": {
        "societe": [
            "Société coopérative de production à responsabilité limitée",
            "Société coopérative d'intérêt collectif à responsabilité limitée",
        ],
    },
    "Création SCIC - SCOP SAS": {
        "societe": [
            "Société coopérative de production par actions simplifiée",
            "Société coopérative d'intérêt collectif par actions simplifiéee",
        ],
    },
    "Transfert siège hors département (Annonce de départ)": {  
        "societe": [
            "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            "Entreprise unipersonnelle à responsabilité limitée",
            "Exploitation agricole à responsabilité limitée",
            "Groupement agricole d'exploitation en commun",
            "Groupement foncier agricole",
            "Société à responsabilité limitée",
            "Société à responsabilité limitée à capital variable",
            "Société anonyme",
            "Société Civile",
            "Société Civile de moyens",
            "Société civile d'exploitation agricole",
            "Société civile immobilière",
            "Société civile immobilière à capital variable",
            "Société civile immobilière de construction vente",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            "Société d'exercice libéral à responsabilité limitée",
            "Société d'exercice libéral par action simplifiée",
            "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            "Société en nom collectif",
            "Société Interprofessionnelle de Soins Ambulatoires",
            "Société par actions simplifiée",
            "Société par actions simplifiée à capital variable",
            "Société par actions simplifiée unipersonnelle",
            "Société par actions simplifiée unipersonnelle à capital variable",
        ],
    },
    "Transfert siège hors département (Annonce d'arrivée)": {
        "societe": [
            "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            "Entreprise unipersonnelle à responsabilité limitée",
            "Exploitation agricole à responsabilité limitée",
            "Groupement agricole d'exploitation en commun",
            "Groupement foncier agricole",
            "Société à responsabilité limitée",
            "Société à responsabilité limitée à capital variable",
            "Société anonyme",
            "Société Civile",
            "Société Civile de moyens",
            "Société civile d'exploitation agricole",
            "Société civile immobilière",
            "Société civile immobilière à capital variable",
            "Société civile immobilière de construction vente",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            "Société d'exercice libéral à responsabilité limitée",
            "Société d'exercice libéral par action simplifiée",
            "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            "Société en nom collectif",
            "Société Interprofessionnelle de Soins Ambulatoires",
            "Société par actions simplifiée",
            "Société par actions simplifiée à capital variable",
            "Société par actions simplifiée unipersonnelle",
            "Société par actions simplifiée unipersonnelle à capital variable",
        ],
    },
    "Avis Administratifs": {
        "societe": [
            "Association d'Avocats à Responsabilité Professionnelle Individuelle",
            "Entreprise unipersonnelle à responsabilité limitée",
            "Exploitation agricole à responsabilité limitée",
            "Groupement agricole d'exploitation en commun",
            "Groupement foncier agricole",
            "Société à responsabilité limitée",
            "Société à responsabilité limitée à capital variable",
            "Société anonyme",
            "Société Civile",
            "Société Civile de moyens",
            "Société civile d'exploitation agricole",
            "Société civile immobilière",
            "Société civile immobilière à capital variable",
            "Société civile immobilière de construction vente",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
            "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
            "Société d'exercice libéral à responsabilité limitée",
            "Société d'exercice libéral par action simplifiée",
            "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
            "Société en nom collectif",
            "Société Interprofessionnelle de Soins Ambulatoires",
            "Société par actions simplifiée",
            "Société par actions simplifiée à capital variable",
            "Société par actions simplifiée unipersonnelle",
            "Société par actions simplifiée unipersonnelle à capital variable",
        ],
    },
};